import { render, staticRenderFns } from "./HumanResourcesMatrixHeader.vue?vue&type=template&id=f641825e"
import script from "./HumanResourcesMatrixHeader.vue?vue&type=script&lang=js"
export * from "./HumanResourcesMatrixHeader.vue?vue&type=script&lang=js"
import style0 from "./HumanResourcesMatrixHeader.vue?vue&type=style&index=0&id=f641825e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports